module.exports = __webpack_public_path__ + "media/arrows/arrow--blue-600-d7458754.svg";